const entry = (id, fields) => ({ sys: { id }, fields })

const pauseCancelSurvey = entry('35Nn6jKbDULjiAJENzTjlC', {
  id: 111,
  name: 'Coach - Client Churner Survey',
  sections: [
    entry('local-demo-pause-cancel-section', {
      name: 'Coach Questions',
      questions: [
        entry('local-demo-cancellation-reasons', {
          id: 5426,
          type: 'multiSelect',
          text: 'Which reasons best describe the pause or cancellation?',
          isRequired: true,
          responses: [
            entry('local-demo-reason-program', {
              id: 1218,
              text: 'The program was not the right fit.',
            }),
            entry('local-demo-reason-logistics', {
              id: 1222,
              text: 'Bugs or logistical issues.',
            }),
          ],
        }),
        entry('local-demo-pause-reason', {
          id: 308,
          type: 'longText',
          text: 'Why did you pause or cancel the client?',
          isRequired: true,
        }),
        entry('local-demo-improvements', {
          id: 309,
          type: 'longText',
          text: 'What could we improve for them?',
          isRequired: true,
        }),
      ],
    }),
  ],
})

export const createLocalContentfulClient = () => ({
  getEntry: async id => {
    if (id === pauseCancelSurvey.sys.id) return pauseCancelSurvey
    throw new Error(`Contentful entry ${id} is unavailable in local demo mode`)
  },
  getEntries: async () => ({ items: [] }),
})
